<script lang="ts">
    
    import { onMount } from "svelte";
    import { ConfigurationManager } from "../../ConfigurationManager";

    import { Slot } from "../../model/Slot";
    import { DefaultErrorHandler } from "../../utility/ContextHelper.svelte";
    import jQuery from "jquery";
    import PromisedComponentHandler from "../components/PromisedComponentHandler.svelte";
    import SlotInfoCard from "../fragments/SlotInfoCard.svelte";
    import { AuthInfo, getAuthInfo } from "../../utility/AccountUtility";

    let slots: Slot[] = $state([]);


    let slotsByGame: Map<string,Slot[]> = $derived(updateGamesToSlotsMap(slots));

    
    let cfgMng = ConfigurationManager.getInstance();

    let auth: AuthInfo = getAuthInfo();

    let gameManager = cfgMng.gamesController;

    function updateGamesToSlotsMap(incomingSlots: Slot[]): Map<string,Slot[]> {
        let result: Map<string,Slot[]> = new Map();
        for(let s of incomingSlots) {
            if(!result.has(s.gameId)) {
                result.set(s.gameId, []);
            }
            result.get(s.gameId).push(s);
        }

        const sorted = [...result].sort();
        const map2 = new Map(sorted);

        return map2;
    }

    onMount(() => {
        gameManager.getAllSlots().then((incoming: Slot[]) => {
            slots = incoming;

        }).catch(DefaultErrorHandler);
    });

    /**
     * Defines ascending vs descending order
     */
    let theOrder: number = 1;

    /**
     * The attribute to sort by based on the column head name
     */
    let sortBy: string = "name";

    let sortingIds: string[] = [
        "name",
        "game",
        "status",
        "progress",
        "volume",
    ];

    /**
     * A map of column head names to actual attribute names of a booking or booking request
     */
    let mapSortingIdsToAttribute = {
        "name": "name",
        "game": "gameId",
        "status": "status",
        "progress": "volumeSpent",
        "volume": "volumeTotal",
    };


    /**
     * 
     * @param triggerParameter This parameter is only used to trigger the automatic svelta update once the parameter is updated
     */
    function updateSorting(triggerParameter: any) {
        // Get the actual attribute name from column head name
        let attirbuteName = mapSortingIdsToAttribute[sortBy];

        if(!attirbuteName) {
            return;
        }

        // Compare function for any attribute
        function defaultCompare(a: (Slot), b: (Slot)) : number {
            if(a[attirbuteName] < b[attirbuteName]) {
                return -1*theOrder;
            } else if(a[attirbuteName] > b[attirbuteName]) {
                return 1*theOrder;
            }
            return 0*theOrder;
        }

        slots = slots.sort(defaultCompare);
    }



    function headerClicked(event: MouseEvent & { currentTarget: EventTarget & HTMLTableCellElement; }) {
        let clickedHeaderAttribute: string = jQuery(event.target).attr('id');

        if(sortBy == clickedHeaderAttribute) {
            theOrder *= -1;
        } else {
            sortBy = clickedHeaderAttribute;
            theOrder = 1;
        }

        updateSorting(null);
    }
</script>
<h1>Your Slots</h1>
<!-- Title -->
<h2 class="h4 text-uppercase my-4">Slots</h2>


{#if slots}
    {#each slotsByGame.entries() as entry}
        <h2><PromisedComponentHandler  retrievalPromise={entry[1][0].game}>
            {#snippet children(game)}
                <a href="#slots-{entry[0]}" role="button" style="cursor: pointer;" data-bs-toggle="collapse" data-bs-target="#slots-{entry[0]}" aria-expanded="true" aria-controls="slots-{entry[0]}">{game.name}</a>
            {/snippet}
        </PromisedComponentHandler></h2>
        <div id="slots-{entry[0]}" class="row collapse show">
            {#each entry[1] as slot}
                <div class="col-lg-4 col-12 py-2">
                    <SlotInfoCard slot={slot} showLinkToPromptEngineering={true} showLinkToStats={true} showBookingButton={auth.isAdvertiser()} class="h-100"></SlotInfoCard>
                </div>
            {/each}
        </div>
    {/each}
{/if}
